export default __webpack_public_path__ + "static/media/webusingreactjs4.e973daae.jpg";